export const serverTypes = [
  {
    icon: "ri-server-line",
    title: "Servidor dedicado",
    description:
      "Recursos exclusivos para aplicações que exigem o máximo de desempenho, controle e previsibilidade.",
  },
  {
    icon: "ri-cloud-line",
    title: "VPS em nuvem",
    description:
      "Ambientes virtualizados com recursos dedicados, ideais para quem precisa de flexibilidade e liberdade de configuração.",
  },
  {
    icon: "ri-stack-line",
    title: "Cloud e escalabilidade",
    description:
      "Estruturas que crescem conforme a demanda, acompanhando o ritmo do seu projeto sem perder estabilidade.",
  },
  {
    icon: "ri-settings-5-line",
    title: "Infraestrutura personalizada",
    description:
      "Soluções montadas sob medida para necessidades específicas da sua empresa.",
  },
];

export const serverBenefits = [
  {
    icon: "ri-speed-up-line",
    title: "Alto desempenho",
    description: "Recursos dedicados para aplicações que não podem perder velocidade.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Segurança",
    description: "Camadas de proteção para manter os seus dados e aplicações seguras.",
  },
  {
    icon: "ri-database-2-line",
    title: "Backups",
    description: "Estrutura preparada para proteção adicional das informações do seu projeto.",
  },
  {
    icon: "ri-map-pin-2-line",
    title: "Servidores no Brasil",
    description: "Infraestrutura localizada no Brasil, mais próxima do seu público.",
  },
  {
    icon: "ri-line-chart-line",
    title: "Escalabilidade",
    description: "Recursos ajustáveis conforme o crescimento da sua operação.",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "Suporte especializado",
    description: "Atendimento próximo de quem entende de infraestrutura.",
  },
];

export const serverUseCases = [
  {
    icon: "ri-shopping-bag-3-line",
    title: "E-commerce de alto tráfego",
    description: "Lojas virtuais que não podem ficar fora do ar em picos de acesso.",
  },
  {
    icon: "ri-code-s-slash-line",
    title: "Sistemas e aplicações web",
    description: "Ambientes para sistemas internos e aplicações que exigem mais recursos.",
  },
  {
    icon: "ri-database-line",
    title: "Bancos de dados e APIs",
    description: "Estrutura dedicada para dados e integrações com estabilidade.",
  },
  {
    icon: "ri-global-line",
    title: "Projetos com alto volume",
    description: "Operações que precisam de capacidade e previsibilidade de desempenho.",
  },
];

export const serverSteps = [
  {
    icon: "ri-chat-3-line",
    title: "Fale com um especialista",
    description: "Conte o que o seu projeto precisa e como ele funciona hoje.",
  },
  {
    icon: "ri-search-eye-line",
    title: "Analisamos a demanda",
    description: "Avaliamos recursos, volume e objetivos para dimensionar a estrutura.",
  },
  {
    icon: "ri-settings-3-line",
    title: "Configuramos o ambiente",
    description: "Montamos e ajustamos os recursos conforme a necessidade do projeto.",
  },
  {
    icon: "ri-checkbox-circle-line",
    title: "Acompanhamos a operação",
    description: "Seguimos por perto para manter tudo estável e evoluindo.",
  },
];

export const dedicatedPlans = [
  {
    name: "Dedicado 32GB RAM 2TB (BR)",
    audience: "Servidor dedicado com discos convencionais para grande volume de dados.",
    price: "979,90",
    unit: "/mês",
    highlighted: false,
    specs: [
      { label: "Memória", value: "32 GB RAM" },
      { label: "Disco", value: "2.000 GB HD" },
      { label: "CPU", value: "8x 3.2 GHz" },
      { label: "Tráfego", value: "4.000 GB (link 500 Mbit)" },
    ],
    features: [
      "DirectAdmin ou cPanel opcionais",
      "vCore de CPU 100% garantido",
      "Taxa de ativação: R$ 478,80",
    ],
  },
  {
    name: "Dedicado 32GB RAM 4TB HD / Tráfego (BR)",
    audience: "Para operações que precisam de bastante espaço e tráfego.",
    price: "1.119,90",
    unit: "/mês",
    highlighted: false,
    specs: [
      { label: "Memória", value: "32 GB RAM" },
      { label: "Disco", value: "4.000 GB HD" },
      { label: "CPU", value: "8x 3.2 GHz" },
      { label: "Tráfego", value: "6.000 GB (link 500 Mbit)" },
    ],
    features: [
      "DirectAdmin ou cPanel opcionais",
      "vCore de CPU 100% garantido",
      "Taxa de ativação: R$ 838,80",
    ],
  },
  {
    name: "Dedicado 32GB RAM 570GB SSD (BR)",
    audience: "Servidor dedicado com disco SSD para respostas mais rápidas.",
    price: "979,90",
    unit: "/mês",
    highlighted: false,
    specs: [
      { label: "Memória", value: "32 GB RAM" },
      { label: "Disco", value: "570 GB SSD" },
      { label: "CPU", value: "8x 3.2 GHz" },
      { label: "Tráfego", value: "1.000 GB (link 500 Mbit)" },
    ],
    features: [
      "DirectAdmin ou cPanel opcionais",
      "vCore de CPU 100% garantido",
      "Taxa de ativação: R$ 1.080,00",
    ],
  },
  {
    name: "Dedicado SSD 32GB RAM 1000GB (RAID10)",
    audience: "Estrutura SSD em RAID10 para desempenho e proteção dos dados.",
    price: "979,90",
    unit: "/mês",
    highlighted: false,
    specs: [
      { label: "Memória", value: "32 GB RAM" },
      { label: "Disco", value: "1.000 GB SSD" },
      { label: "CPU", value: "8x 3.2 GHz" },
      { label: "Tráfego", value: "1.000 GB (link 500 Mbit)" },
    ],
    features: [
      "DirectAdmin ou cPanel opcionais",
      "vCore de CPU 100% garantido",
      "Taxa de ativação: R$ 1.080,00",
    ],
  },
  {
    name: "Dedicado SSD 32GB RAM 1440GB (RAID10)",
    audience: "Mais espaço SSD em RAID10 para aplicações exigentes.",
    price: "1.175,90",
    unit: "/mês",
    highlighted: false,
    specs: [
      { label: "Memória", value: "32 GB RAM" },
      { label: "Disco", value: "1.440 GB SSD" },
      { label: "CPU", value: "8x 3.2 GHz" },
      { label: "Tráfego", value: "2.000 GB (link 500 Mbit)" },
    ],
    features: [
      "DirectAdmin ou cPanel opcionais",
      "vCore de CPU 100% garantido",
      "Taxa de ativação: R$ 1.080,00",
    ],
  },
  {
    name: "Dedicado SSD 32GB RAM 1800GB (RAID10)",
    audience: "Para projetos que precisam de alto volume de armazenamento SSD.",
    price: "1.399,90",
    unit: "/mês",
    highlighted: false,
    specs: [
      { label: "Memória", value: "32 GB RAM" },
      { label: "Disco", value: "1.800 GB SSD" },
      { label: "CPU", value: "8x 3.2 GHz" },
      { label: "Tráfego", value: "3.000 GB (link 500 Mbit)" },
    ],
    features: [
      "DirectAdmin ou cPanel opcionais",
      "vCore de CPU 100% garantido",
      "Taxa de ativação: R$ 1.080,00",
    ],
  },
  {
    name: "Dedicado SSD 32GB RAM 3600GB (RAID10)",
    audience: "Armazenamento SSD ampliado para grandes bases de dados.",
    price: "1.679,90",
    unit: "/mês",
    highlighted: false,
    specs: [
      { label: "Memória", value: "32 GB RAM" },
      { label: "Disco", value: "3.600 GB SSD" },
      { label: "CPU", value: "8x 3.2 GHz" },
      { label: "Tráfego", value: "2.000 GB (link 500 Mbit)" },
    ],
    features: [
      "DirectAdmin ou cPanel opcionais",
      "vCore de CPU 100% garantido",
      "Taxa de ativação: R$ 1.080,00",
    ],
  },
  {
    name: "Dedicado SSD 32GB RAM 5400GB (RAID10)",
    audience: "Muito espaço SSD em RAID10 para operações de grande porte.",
    price: "1.959,90",
    unit: "/mês",
    highlighted: false,
    specs: [
      { label: "Memória", value: "32 GB RAM" },
      { label: "Disco", value: "5.400 GB SSD" },
      { label: "CPU", value: "8x 3.2 GHz" },
      { label: "Tráfego", value: "3.000 GB (link 500 Mbit)" },
    ],
    features: [
      "DirectAdmin ou cPanel opcionais",
      "vCore de CPU 100% garantido",
      "Taxa de ativação: R$ 780,00",
    ],
  },
  {
    name: "Dedicado SSD 64GB RAM 400GB SSD",
    audience: "Mais memória RAM com disco SSD para aplicações que exigem agilidade.",
    price: "1.175,90",
    unit: "/mês",
    highlighted: false,
    specs: [
      { label: "Memória", value: "64 GB RAM" },
      { label: "Disco", value: "400 GB SSD" },
      { label: "CPU", value: "8x 3.2 GHz" },
      { label: "Tráfego", value: "1.000 GB (link 500 Mbit)" },
    ],
    features: [
      "DirectAdmin ou cPanel opcionais",
      "vCore de CPU 100% garantido",
      "Taxa de ativação: R$ 1.200,00",
    ],
  },
  {
    name: "Dedicado SSD 128GB RAM 1TB SSD (-1890G)",
    audience: "Servidor dedicado com 128 GB de RAM para cargas intensas.",
    price: "2.099,90",
    unit: "/mês",
    highlighted: false,
    specs: [
      { label: "Memória", value: "128 GB RAM" },
      { label: "Disco", value: "1.000 GB SSD" },
      { label: "CPU", value: "12x 2.1 GHz" },
      { label: "Tráfego", value: "3.000 GB (link 500 Mbit)" },
    ],
    features: [
      "DirectAdmin ou cPanel opcionais",
      "vCore de CPU 100% garantido",
      "Taxa de ativação: R$ 1.440,00",
    ],
  },
  {
    name: "Dedicado SSD 128GB RAM 2TB SSD (-1.7T)",
    audience: "Alta capacidade de memória e armazenamento SSD.",
    price: "2.239,90",
    unit: "/mês",
    highlighted: false,
    specs: [
      { label: "Memória", value: "128 GB RAM" },
      { label: "Disco", value: "2.000 GB SSD" },
      { label: "CPU", value: "12x 2.1 GHz" },
      { label: "Tráfego", value: "4.000 GB (link 500 Mbit)" },
    ],
    features: [
      "DirectAdmin ou cPanel opcionais",
      "vCore de CPU 100% garantido",
      "Taxa de ativação: R$ 1.920,00",
    ],
  },
  {
    name: "Dedicado SSD 128GB RAM 3TB SSD (-2.4T)",
    audience: "Para operações críticas que exigem o máximo de recursos.",
    price: "2.519,90",
    unit: "/mês",
    highlighted: false,
    specs: [
      { label: "Memória", value: "128 GB RAM" },
      { label: "Disco", value: "3.000 GB SSD" },
      { label: "CPU", value: "12x 2.1 GHz" },
      { label: "Tráfego", value: "6.000 GB (link 500 Mbit)" },
    ],
    features: [
      "DirectAdmin ou cPanel opcionais",
      "vCore de CPU 100% garantido",
      "Taxa de ativação: R$ 1.080,00",
    ],
  },
  {
    name: "Dedicado SSD 128GB RAM 4TB SSD (-3.5T)",
    audience: "A configuração mais robusta, para os projetos mais exigentes.",
    price: "2.799,90",
    unit: "/mês",
    highlighted: false,
    specs: [
      { label: "Memória", value: "128 GB RAM" },
      { label: "Disco", value: "4.000 GB SSD" },
      { label: "CPU", value: "12x 2.1 GHz" },
      { label: "Tráfego", value: "8.000 GB (link 500 Mbit)" },
    ],
    features: [
      "DirectAdmin ou cPanel opcionais",
      "vCore de CPU 100% garantido",
      "Taxa de ativação: R$ 2.280,00",
    ],
  },
];

export const servidoresFaqs = [
  {
    question: "Qual a diferença entre hospedagem, VPS e servidor dedicado?",
    answer:
      "A hospedagem compartilhada atende sites e projetos menores. O VPS oferece recursos dedicados com flexibilidade. O servidor dedicado entrega a estrutura completa exclusiva para o seu projeto. Fale com um especialista para indicarmos o melhor caminho.",
  },
  {
    question: "Vocês trabalham com servidores no Brasil?",
    answer:
      "Sim. Nossa infraestrutura prioriza servidores localizados no Brasil, o que ajuda a reduzir a latência e melhorar a experiência dos seus usuários.",
  },
  {
    question: "Posso migrar um projeto que já está em outro servidor?",
    answer:
      "Sim. A nossa equipe auxilia na migração, avaliando a estrutura atual e cuidando da transição para manter tudo funcionando durante a mudança.",
  },
  {
    question: "A infraestrutura pode crescer depois?",
    answer:
      "Sim. As soluções podem ser ajustadas conforme o seu projeto cresce, ampliando recursos ou evoluindo para uma estrutura mais robusta.",
  },
  {
    question: "Como funciona o suporte em infraestrutura?",
    answer:
      "Oferecemos atendimento próximo para ajudar na configuração e na manutenção da sua estrutura. Fale com um especialista para conhecer as condições atuais.",
  },
];